import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' }, // DEFAULT ROUTE
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(x => x.AuthModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('./orders/orders.module').then(x => x.OrdersModule)
  },
  {
    path: 'customers',
    loadChildren: () => import('./customers/customers.module').then(x => x.CustomersModule)
  },
  {
    path: 'payments',
    loadChildren: () => import('./payments/payments.module').then(x => x.PaymentsModule)
  },
  {
    path: 'catalogs',
    loadChildren: () => import('./catalogs/catalogs.module').then(x => x.CatalogsModule)
  },
  {
    path: 'accounting',
    loadChildren: () => import('./accounting/accounting.module').then(x => x.AccountingModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(x => x.ReportsModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(x => x.AdminModule)
  },
  { path: '**', pathMatch: 'full', redirectTo: 'auth/not-found' } // ERROR 404
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
